import React from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  Chip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type NotificationItem = string | { title: string; isNew?: boolean };

type Props = {
  open: boolean;
  onClose: () => void;
  notifications: NotificationItem[];
};

const SeeAllNotificationsModal: React.FC<Props> = ({
  open,
  onClose,
  notifications
}) => {
  const getText = (item: NotificationItem) =>
    typeof item === "string" ? item : item.title;
  const getIsNew = (item: NotificationItem, index: number) =>
    typeof item === "string" ? index === 0 : Boolean(item.isNew);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: 500 },
          boxSizing: "border-box",
          borderTopLeftRadius: { sm: 0 },
          borderBottomLeftRadius: { sm: 8 },
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)"
        }
      }}
    >
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box
          sx={{
            px: 3,
            py: 2.5,
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #E5E7EB"
          }}
        >
          <Typography variant="h6" fontWeight={700} sx={{ flex: 1 }}>
            Notifications
          </Typography>
          <IconButton onClick={onClose} size="small" aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Box>

        {/* List */}
        <Box sx={{ flex: 1, overflowY: "auto" }}>
          <List disablePadding>
            {notifications.map((item, idx) => (
              <ListItem
                key={idx}
                sx={{
                  px: 3,
                  py: 1,
                  alignItems: "flex-start",
                  gap: 1.5,
                  borderBottom:
                    idx !== notifications.length - 1
                      ? "0px solid #F1F5F9"
                      : "none"
                }}
              >
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    bgcolor: "#111827",
                    borderRadius: "50%",
                    mt: 1
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    flex: 1,
                    minWidth: 0
                  }}
                >
                  <Typography sx={{ fontSize: 14, lineHeight: 1.55, flex: 1 }}>
                    {getText(item)}
                  </Typography>
                  {getIsNew(item, idx) && (
                    <Chip
                      label="New"
                      size="small"
                      sx={{
                        height: 24,
                        bgcolor: "#3A1C73",
                        color: "#fff",
                        borderRadius: "9999px",
                        "& .MuiChip-label": { px: 1 }
                      }}
                    />
                  )}
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SeeAllNotificationsModal;
